var _a, _b, _c, _d;
// 产品时效-productCode
export var PRODUCT = {
    SF_TODAY: 'T104',
    HALF_DAY: 'T103',
    SF_NEXT_MORNING: 'T801',
    SF_NEXT_MORNING_DOCUMENT: 'T2-DOC',
    SF_EXPRESS: 'T4',
    SF_EXPRESS_LAND_TRANSPORTATION: 'T6',
    INTERNATIONAL_SPECIAL_OFFER: 'T9',
    HIGH_SPEED_RAIL: 'T108',
    HIGH_SPEED_RAIL_NEXT_MORNING: 'T109',
    SF_TODAY_T105: 'T105',
    HEAVY_CARGO_PACKAGE: 'SE0100',
    STANDARD_LTL: 'SE0101',
    LARGE_LTL: 'SE0114',
    STANDARD_HEAVY_DELIVERY: 'SE0141',
    STANDARD_HEAVY_DELIVERY_D: 'SE0141-D',
    MEDICINE_RELIEF_DELIVERY: 'SP321',
    DEDICATED_GENERAL_TRANSPORT: 'SE0091',
    Logistics_general_transport: 'SE0006',
    HEAVY_CARGO_PACKAGE_B: 'SE010001',
    CITY_EXPRESS: 'T121',
    ACROSS_CITY_EXPRESS: 'T120',
    CITY_RUSH: 'KUAISUDA',
    BOX_TO_BOX_EXPRESS: 'T4_TOBOX',
    BOX_TO_BOX_SPECIAL_OFFER: 'T6_TOBOX',
    BOX_TO_DOOR_EXPRESS: 'T4_TOHOME',
    EXCLUSIVE_EXPRESS: 'T105',
    EXCLUSIVE_DELIVERY: 'T11',
    BOX_TO_DOOR_SPECIAL_OFFER: 'T6_TOHOME',
    LAND_CHANGE_TRANSPORTATIO: 'SE0128',
    CITY_HALY_DAY: 'SE0147',
    CITY_NEXT_DAY: 'SE0148',
    SF_TODAY_T1: 'T1',
    SF_EARLY_MORNING: 'SE0157' // 特早达（第二天早上九点半前送达）
};
// 产品时效对于的名称-productDisplayName
export var PRODUCT_NAME_MAP = (_a = {},
    _a[PRODUCT.SF_TODAY] = '顺丰即日',
    _a[PRODUCT.HALF_DAY] = '半日达',
    _a[PRODUCT.SF_NEXT_MORNING] = '顺丰次晨',
    _a[PRODUCT.SF_EXPRESS] = '顺丰特快',
    _a[PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION] = '顺丰标快',
    _a[PRODUCT.INTERNATIONAL_SPECIAL_OFFER] = '国际特惠',
    _a[PRODUCT.HIGH_SPEED_RAIL] = '高铁极速达',
    _a[PRODUCT.HIGH_SPEED_RAIL_NEXT_MORNING] = '高铁极速达次晨',
    _a[PRODUCT.SF_TODAY_T105] = '顺丰即日',
    _a[PRODUCT.HEAVY_CARGO_PACKAGE] = '重货包裹',
    _a[PRODUCT.STANDARD_LTL] = '标准零担',
    _a[PRODUCT.MEDICINE_RELIEF_DELIVERY] = '医药安心递',
    _a[PRODUCT.DEDICATED_GENERAL_TRANSPORT] = '专线普运',
    _a[PRODUCT.Logistics_general_transport] = '物流普运',
    _a[PRODUCT.HEAVY_CARGO_PACKAGE_B] = '重货包裹B',
    _a[PRODUCT.CITY_EXPRESS] = '同城特快',
    _a[PRODUCT.EXCLUSIVE_DELIVERY] = '专享急件',
    _a[PRODUCT.CITY_HALY_DAY] = '同城半日达',
    _a[PRODUCT.CITY_RUSH] = '同城急送',
    _a[PRODUCT.LAND_CHANGE_TRANSPORTATIO] = '顺丰标快',
    _a[PRODUCT.SF_TODAY_T1] = '顺丰即日',
    _a[PRODUCT.SF_EARLY_MORNING] = '特早达',
    _a);
/**
 * 时效类型对应的产品代码(获取优惠券下发给会员)
 */
export var PRODUCT_TYPE_MAP = (_b = {},
    _b[PRODUCT.SF_EXPRESS] = 'S1',
    _b[PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION] = 'S2',
    _b[PRODUCT.SF_TODAY] = 'T1',
    _b[PRODUCT.HIGH_SPEED_RAIL] = 'SE0096',
    _b[PRODUCT.HIGH_SPEED_RAIL_NEXT_MORNING] = 'SE0097',
    _b[PRODUCT.SF_NEXT_MORNING] = 'T2',
    _b[PRODUCT.HEAVY_CARGO_PACKAGE] = 'SE0100',
    _b[PRODUCT.STANDARD_LTL] = 'SE0101',
    _b[PRODUCT.CITY_EXPRESS] = 'SE000205',
    _b[PRODUCT.EXCLUSIVE_EXPRESS] = 'T11',
    _b[PRODUCT.STANDARD_HEAVY_DELIVERY] = 'SE0141',
    _b[PRODUCT.STANDARD_HEAVY_DELIVERY_D] = 'SE0141-D',
    _b[PRODUCT.SF_EARLY_MORNING] = 'SE0157',
    _b);
// 产品代码对应时效类型(动态折扣系统获取时效名称)
export var PRODUCT_CODE_MAP = {
    S1: PRODUCT.SF_EXPRESS,
    S2: PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION,
    T1: PRODUCT.SF_TODAY,
    SE0096: PRODUCT.HIGH_SPEED_RAIL,
    SE0097: PRODUCT.HIGH_SPEED_RAIL_NEXT_MORNING,
    T2: PRODUCT.SF_NEXT_MORNING,
    SE0100: PRODUCT.HEAVY_CARGO_PACKAGE,
    SE0101: PRODUCT.STANDARD_LTL,
    SE000205: PRODUCT.CITY_EXPRESS,
    SE0141: PRODUCT.STANDARD_HEAVY_DELIVERY,
    'SE0141-D': PRODUCT.STANDARD_HEAVY_DELIVERY_D,
    SE0157: PRODUCT.SF_EARLY_MORNING
};
// 丰巢自寄码产品编码
export var EXPRESS_PRODUCT_MAP = (_c = {},
    /** 顺丰标快 */
    _c[PRODUCT.SF_EXPRESS] = '1001',
    /** 顺丰特惠 */
    _c[PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION] = '1002',
    /** 柜到柜标快 */
    _c[PRODUCT.BOX_TO_BOX_EXPRESS] = '1004',
    /** 柜到柜特惠 */
    _c[PRODUCT.BOX_TO_BOX_SPECIAL_OFFER] = '1006',
    /** 柜到门标快 */
    _c[PRODUCT.BOX_TO_DOOR_EXPRESS] = '1005',
    /** 柜到门特惠 */
    _c[PRODUCT.BOX_TO_DOOR_SPECIAL_OFFER] = '1007',
    _c);
// 默认时效信息的另外两个要素
export var DEFAULT_PRODUCT_FACTOR = (_d = {},
    // 重货包裹为SE0100
    _d[PRODUCT.HEAVY_CARGO_PACKAGE] = {
        cargoType: 'SP635',
        expressTypeCode: 'B2'
    },
    // 标准零担为SE0101
    _d[PRODUCT.STANDARD_LTL] = {
        cargoType: 'SP636',
        expressTypeCode: 'B2'
    },
    // 兜底时效的另外两个要素
    _d[PRODUCT.SF_EXPRESS] = {
        cargoType: 'C201',
        expressTypeCode: 'B1'
    },
    // T6(陆运)时效两个要素
    _d[PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION] = {
        cargoType: 'T6',
        expressTypeCode: 'B1'
    },
    _d);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/business-constants/dist/esm/product.js
// module id = null
// module chunks = 